import { apiClient } from '../api';
import { Path } from '../api/backendUrl';

export const getLandingPage = async (keywords: string[] = []) => {
  try {
    const response = await apiClient.get(`/${Path.getLandingPage}`, {
      // JSON-encoded single param: a phrase may contain commas, and axios
      // array serialization (?keywords[]=a) is awkward for Fastify. The BFF
      // accepts both the JSON string and a plain comma string.
      params: keywords.length
        ? { keywords: JSON.stringify(keywords) }
        : undefined,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching Landing Page:', error);
    throw error;
  }
};

export const getAllMembershipPlans = async () => {
  try {
    const res = await apiClient.get(Path.membership);
    return res.data;
  } catch (error: any) {
    console.log('ERROR: ', error);
    // logger.error(error);
    throw error;
  }
};

export const createSubscription = async (
  planId: string,
  isAnnual: boolean,
  customerEmail: string | undefined
) => {
  try {
    const res = await apiClient.post(Path.membershipCreateSubscription, {
      planId,
      isAnnual,
      customerEmail,
      bp: true,
    });
    return res.data;
  } catch (error: any) {
    console.log('ERROR: ', error);
    // logger.error(error);
    throw error;
  }
};
